<template>
<v-app>   
        <v-container align="left">
            <v-row>
                <v-col cols=12> 
                    <v-dialog
                        v-model="espereDialog"
                        hide-overlay
                        persistent
                        width="300"
                    >
                        <v-card
                        color="primary"
                        dark
                        >
                        <v-card-text>
                            Por favor espere
                            <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                            ></v-progress-linear>
                        </v-card-text>
                        </v-card>
                    </v-dialog>
                    
                        <Paciente 
                            ref="pacienteComponent"
                            :key="JSON.stringify(account_info)"
                            :account_info_="account_info" 
                            :isAccountEdit="true"
                            @account_info_from_child="handlerDataSave">
                        </Paciente>
                  
                </v-col>
            </v-row>
        </v-container>	
</v-app>
</template>

<script>

import axios from 'axios';
import {getPacienteData, getPeople, updatePaciente} from '@/services/monolito';
import pacienteMixin from '@/mixins/pacienteMixin';
import errorsMixin from '@/mixins/errorsMixin';
import Paciente from '@/components/Paciente.vue';
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    name: "Cuenta",
    mixins: [pacienteMixin, errorsMixin, validationMixin],
    components: {
        Paciente
    },
    // Data
    data() {
        return {
            account_info: {
                mail:"",
                gender:"",
                name: "",
                lastname: "",
                password: "" ,
                dni: "",
                roles: ["end_user"],
                dob: "",
                active: true,
                deceased: false,
                street:"",
                subdivision:"",
                insuranse:  "",
                insuranseNumber:  "",
                telefono:"",
                city:"",
            },
            // local variables not to be passed
            mail_confirm: '',
            pass_confirm: '',
            goptions: [
                    { text: 'MASCULINO', value: 'm' },
                    { text: 'FEMENINO', value: 'f' }
                ],
            insuranseOptions: [],
            provincias:[],
            espereDialog: false,
        }
    },
    validations: {
        account_info: {
            name: { required },
            lastname: { required },
            gender: { required },
            insuranse: { required },
            city: { required },
            province: { required },
            telefono: { required }
        }
    },
    created(){
        this.get_account()
    },
    watch: {
        account_info: {
            handler(newVal) {

            },
            deep: true
        }
    },
    // Using Axios
    methods: {
       handlerDataSave: function (datos){
           this.espereDialog = true
           this.account_info = datos
           this.update_account()
       },
       async get_account () {
            // Obtener el email del perfil del usuario logueado
            const userProfile = this.$store.state.user_profile;
            const credentials = this.$store.state.credentials;
            let identifier = null;
            
            // Intentar obtener el identificador en orden de prioridad
            if (userProfile) {
                // Buscar email en diferentes campos posibles del perfil
                identifier = userProfile.email || userProfile.username || userProfile.mail || userProfile.fedacct;
            }
            
            // Si no se encontró en el perfil, buscar en credentials
            if (!identifier && credentials) {
                identifier = credentials.fedacct || credentials.dni;
            }
            
            // Si aún no tenemos identificador, usar el DNI del formulario
            if (!identifier && this.account_info.dni) {
                identifier = this.account_info.dni;
            }
            
            if (!identifier) {
                console.error('Error: No se encontró ningún identificador válido');
                return;
            }
            
            // Usar el nuevo sistema unificado
            const resultado = await this.consultarPaciente(identifier);
            
            if (!resultado.success) {
                console.error('Error: No se pudo obtener los datos del paciente:', resultado.error);
                return;
            }
            
            // Procesar los datos según el tipo de consulta
            const datosProcesados = this.procesarDatosPaciente(resultado.data, resultado.tipoConsulta);
            
            if (!datosProcesados || !datosProcesados.paciente) {
                console.error('Error: Datos del paciente inválidos');
                return;
            }
            
            const data = datosProcesados.paciente;
            const direccion = datosProcesados.direccion || {};
            const contacto = datosProcesados.contacto || {};
            
            // Create a temporary object to hold all data
            const newAccountInfo = { ...this.account_info };

            // Assign data with fallbacks for both nested 'party' structure and flat structure
            newAccountInfo.gender = (data.party && data.party.gender) ? data.party.gender : (data.gender || '');
            newAccountInfo.mail = this.$store.state.credentials.fedacct || (data.email || '');
            newAccountInfo.dni = (data.party && data.party.ref) ? data.party.ref : (data.ref || data.code || '');
            newAccountInfo.name = (data.party && data.party.name) ? data.party.name : (data.name || '');
            newAccountInfo.lastname = (data.party && data.party.lastname) ? data.party.lastname : (data.lastname || '');
            newAccountInfo.password = this.$store.state.credentials.password || '';
            this.pass_confirm = this.$store.state.credentials.password || '';
            this.mail_confirm = this.$store.state.credentials.fedacct || (data.email || '');
            newAccountInfo.dob = (data.party && data.party.dob) ? data.party.dob : (data.dob || '');
            
            if (data.seguro) {
                // Handle different structures if 'empresa' exists or if it's direct
                if (data.seguro.empresa) {
                     newAccountInfo.insuranse = data.seguro.empresa.name || data.seguro.empresa.id;
                } else if (data.seguro.name) { // Fallback if seguro is the company itself
                     newAccountInfo.insuranse = data.seguro.name;
                }
                newAccountInfo.insuranseNumber = data.seguro.number || '';
            }
            
            if (direccion && Object.keys(direccion).length > 0) {
                newAccountInfo.street = direccion.street || '';
                newAccountInfo.city = direccion.city || '';
                if (direccion.provincia) {
                    newAccountInfo.subdivision = direccion.provincia.id;
                }
            }
            
            if (contacto && Object.keys(contacto).length > 0) {
                newAccountInfo.telefono = contacto.value || '';
            }
            
            // Assign everything at once to trigger a single update in child component
            console.log('DEBUG: Datos procesados:', datosProcesados);
            console.log('DEBUG: Paciente data:', data);
            console.log('DEBUG: newAccountInfo being assigned:', newAccountInfo);
            this.account_info = newAccountInfo;

            // Forzar la actualización del componente hijo en el siguiente tick
            this.$nextTick(() => {
                if (this.$refs.pacienteComponent) {
                    // El watcher del componente hijo debería ejecutarse automáticamente
                }
            });
        },
        
        initializeUserData() {
            // Obtener datos del usuario logueado del store
            const credentials = this.$store.state.credentials;
            const userProfile = this.$store.state.user_profile;
            
            // Usar email del perfil si está disponible, sino del credentials
            const userEmail = userProfile ? userProfile.email : credentials.fedacct;
            if (userEmail) {
                this.account_info.mail = userEmail;
            }
            
            if (credentials.name) {
                this.account_info.name = credentials.name;
            }
            if (credentials.dni) {
                this.account_info.dni = credentials.dni;
            }
        },
        
        async update_account(){
            // Verificar que tenemos el DNI antes de actualizar
            if (!this.account_info.dni) {
                await this.$alert({ title: 'DNI requerido', message: 'Error: No se encontró el DNI del paciente', color: 'error' });
                this.espereDialog = false;
                return;
            }
            
            // Usar el nuevo sistema unificado
            const resultado = await this.guardarPaciente(this.account_info, 'update');
            
            if (resultado.success) {
                // Actualizar el store con los nuevos datos
                let authinfo = {
                    federation_acct: this.account_info.mail,
                    password: this.account_info.password,
                    role: this.$store.state.credentials.role,
                    name: this.account_info.name,
                    telefono: this.account_info.telefono,
                    dni: this.account_info.dni
                };
                
                // Update credentials in store
                this.$store.commit('set_credentials', authinfo);
                
                // CRITICAL: Also update user_profile to persist to localStorage
                // Get current profile to merge (avoid losing other fields)
                const currentProfile = this.$store.state.user_profile || {};
                this.$store.commit('set_user_profile', {
                    ...currentProfile,
                    name: this.account_info.name,
                    dni: this.account_info.dni,
                    telefono: this.account_info.telefono,
                    email: this.account_info.mail
                });

                await this.$alert({ title: 'Actualización exitosa', message: 'Los datos se actualizaron correctamente.', color: 'success' });
            } else {
                await this.$alert({ title: 'Error al actualizar', message: 'Error al actualizar los datos: ' + resultado.error, color: 'error' });
            }
            
            this.espereDialog = false;
        },
    },
}
</script>
<style>

  .style-select .vs__search::placeholder,
  .style-select .vs__dropdown-toggle,
  .style-select .vs__search,
  .style-select .vs__selected,
  .style-select .vs__dropdown-menu {
    background: #ffffff;
    border: none;
    text-transform: uppercase;
    font-variant: small-caps;
  }
  .vs__fade-enter-active,
  .vs__fade-leave-active {
        transition: none;
    }
</style>